module.exports = __webpack_public_path__ + "static/media/marketing_use_case_1.7225b1a7.svg";